<template>
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4.5" cy="4.5" r="4.5" fill="#df252a" class="fill" />
  </svg>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

svg {
  width: 0.643rem;
  height: 0.643rem;
}
.icon-red svg .fill {
  fill: #df252a !important;
}
.icon-yellow svg .fill {
  fill: #ffdd46 !important;
}
.icon-green svg .fill {
  fill: #5ed0c2 !important;
}
.icon-pink svg .fill {
  fill: #bc64ff !important;
}
.icon-blue svg .fill {
  fill: #6bb7f4 !important;
}
.package-type-icon svg .fill {
  fill: currentColor;
}
.child-item svg .fill {
  fill: $gray-text;
}
.v-list-item--active svg .fill {
  fill: #df252a;
}
</style>
